/** Default date format for calendar date */
export const CalendarDefaultDateFormat = 'YYYY-MM-DD'

/** Date format for the calendar month shown in the header */
export const CalendarMonthFormat = 'MMMM YYYY'
